import { Injectable } from '@angular/core'
import { ActiveState, EntityState, EntityStore, StoreConfig } from '@datorama/akita'

import { ZaloAPI } from '@etop/api/shop/zalo.api'
import { CursorPaging, Followers, FollowersTab, TotalFollowers } from '@etop/models'

export interface StateOAFollowers extends EntityState<Followers, string>, ActiveState {
    ui: {
        paging: CursorPaging;
        filter: ZaloAPI.FilterFollowersOA;
        currentPage: number;
        tab: FollowersTab;
        isLastPage: boolean;
        sync: TotalFollowers
    };
}

const initialState = {
    ui: {
        paging: null,
        filter: null,
        currentPage: 1,
        tab: FollowersTab.list,
        isLastPage: false,
        sync: null
    }
}

@Injectable({
    providedIn: 'root'
})
@StoreConfig({name: 'OAFOLLOWERSSTORE', resettable: true})
export class OAFollowersStore extends EntityStore<StateOAFollowers> {
    constructor() {
        super(initialState)
    }
}